import { render } from "./StudentCard.vue?vue&type=template&id=2312dc14&scoped=true"
import script from "./StudentCard.vue?vue&type=script&lang=js"
export * from "./StudentCard.vue?vue&type=script&lang=js"

import "./StudentCard.vue?vue&type=style&index=0&id=2312dc14&lang=scss&scoped=true"

import exportComponent from "/home/misha/Рабочий стол/ucsa-system-front-admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2312dc14"]])

export default __exports__